import ViewerSidebar from "../components/ViewerSidebar";
import SettingsLayout from "../components/settings/SettingsLayout";
import SettingsSections from "../components/settings/SettingsSections";

export default function ViewerSettings() {
  const role = (() => {
    try {
      return JSON.parse(localStorage.getItem("user"))?.role;
    } catch {
      return undefined;
    }
  })();

  return (
    <SettingsLayout Sidebar={ViewerSidebar}>
      <SettingsSections role={role} />
    </SettingsLayout>
  );
}
